(() => {
  const loader = document.getElementById('FutureMemoryLoader');
  if (!loader || loader.hidden) return;

  const bar = loader.querySelector('.fm-loader__bar');
  const number = loader.querySelector('.fm-loader__number');
  const startedAt = performance.now();
  const minDuration = Number(loader.dataset.minDuration) || 1200;
  const maxDuration = Math.min(Number(loader.dataset.maxDuration) || 4000, 4000);
  let progress = 0;
  let pageLoaded = document.readyState === 'complete';
  let finished = false;
  let frame;

  const forced = new URLSearchParams(location.search).get('preview_loader') === '1';
  if (!forced && loader.dataset.frequency !== 'every') {
    try { sessionStorage.setItem('future-memory-loader-seen', '1'); } catch (_) {}
  }

  const paint = (value) => {
    progress = Math.max(progress, Math.min(100, value));
    bar.style.transform = `scaleX(${progress / 100})`;
    number.value = String(Math.round(progress)).padStart(2, '0');
  };

  const release = () => {
    if (finished) return;
    finished = true;
    cancelAnimationFrame(frame);
    clearTimeout(loader._fmForceRelease);
    paint(100);
    setTimeout(() => {
      loader.classList.add('is-leaving');
      document.documentElement.classList.remove('fm-loader-active');
      setTimeout(() => {
        loader.hidden = true;
        loader.remove();
      }, 620);
    }, 240);
  };

  const tick = (now) => {
    const elapsed = now - startedAt;
    const visualTarget = Math.min(92, 92 * (1 - Math.exp(-elapsed / 310)));
    paint(visualTarget);
    if (pageLoaded && elapsed >= minDuration) return release();
    if (elapsed >= maxDuration) return release();
    frame = requestAnimationFrame(tick);
  };

  addEventListener('load', () => { pageLoaded = true; }, { once: true });
  addEventListener('pageshow', (event) => {
    if (event.persisted) release();
  });
  frame = requestAnimationFrame(tick);
  setTimeout(release, maxDuration);
})();
